export const loadFlickity = require('bundle-loader?lazy&name=[name]!../lib/flickity');

export const loadMatter = require('bundle-loader?lazy&name=[name]!../lib/matter.pkgd');

export const loadPaper = require('bundle-loader?lazy&name=[name]!paper/dist/paper-core');
